import { render, staticRenderFns } from "./EmailTag.vue?vue&type=template&id=639c4c2f&scoped=true"
import script from "./EmailTag.vue?vue&type=script&lang=js"
export * from "./EmailTag.vue?vue&type=script&lang=js"
import style0 from "./EmailTag.vue?vue&type=style&index=0&id=639c4c2f&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639c4c2f",
  null
  
)

export default component.exports